import { gql } from "@apollo/client";

const GET_ORGANIZATIONS = gql`
  query GetOrganizations(
    $paginationInfo: PaginationInfo
    $filters: OrganizationFilter
    $orderBy: OrganizationOrderBy
    $first: Int
    $last: Int
    $after: String
    $before: String
    $limit: Int
  ) {
    organizations(
      paginationInfo: $paginationInfo
      filters: $filters
      orderBy: $orderBy
      first: $first
      last: $last
      after: $after
      before: $before
      limit: $limit
    ) {
      totalCount
      currentPage
      currentOffset
      perPage
      nodes {
        id
        name
        url
        slug
        status
        archivedSince
        customerPortalVersion
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
`;

const GET_ORGANIZATIONS_FOR_SELECT = gql`
  query GetOrganizationsForSelect($filters: OrganizationFilter) {
    organizations(filters: $filters) {
      nodes {
        id
        name
      }
    }
  }
`;

export { GET_ORGANIZATIONS, GET_ORGANIZATIONS_FOR_SELECT };
